import React from 'react';
import { useTranslation } from 'react-i18next';
import Divider from '@material-ui/core/Divider';
import GeneralContainer from '../../containers/GeneralContainer';
import NetworkingContainer from '../../containers/NetworkingContainer';
import UsersContainer from '../../containers/UsersContainer';
import TrunksContainer from '../../containers/TrunksContainer';
import styles from './summary.module.scss';

const Summary = () => {
    const { t } = useTranslation('common');

    return (
        <div className={styles.container}>
            <div className={styles.firstSubtitle}>
                <span>{t('GENERAL')}</span>
            </div>
            <GeneralContainer />
            <Divider variant="middle" />
            <div className={styles.subtitle}>
                <span>{t('NETWORKING')}</span>
            </div>
            <NetworkingContainer />
            <Divider variant="middle" />
            <div className={styles.subtitle}>
                <span>{t('USERS')}</span>
            </div>
            <UsersContainer />
            <Divider variant="middle" />
            <div className={styles.subtitle}>
                <span>{t('TRUNKS')}</span>
            </div>
            <TrunksContainer />
        </div>
    );
};

export default Summary;
